import Received from './Received';

export default Received;
